<template>
  <div>
    <!-- 退款模式编辑 -->
    <el-dialog :title="$t('message.refundModeEditing')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="content">
        <div class="row" v-for="(item, index) in amountRefundType" :key="index">
          <el-radio v-model="radio" :label="item.key" v-if="item.key != 3">{{
      item.value
    }}</el-radio>
          <el-radio v-model="radio" :label="item.key" v-else>{{ item.value }}
            <el-input v-model="num" type="number" placeholder="人工输入需要赔款的金额"></el-input></el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
      $t("message.ok")
    }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    redactIndex: { type: Object },
    itemData: { type: Object },
    amountRefundType: { type: Array },
  },
  data() {
    return {
      dialogVisible: false,
      radio: "",
      num: "",
    };
  },
  methods: {
    save() {
      if (this.radio == "") {
        return this.$message.error("请选择退款模式");
      }
      //   按数量退
      if (this.radio == 1) {
        let item = this.itemData.list[this.redactIndex.indexs];
        // 商品代赔款
        if (this.redactIndex.amount == "amount_goods_amount") {
          this.num = (
            item.num *
            item.confirm_price *
            this.itemData.exchange_rate
          ).toFixed(0);
        } else if (this.redactIndex.amount == "amount_freight_amount") {
          //国内运费返还
          this.num = (
            item.confirm_freight * this.itemData.exchange_rate
          ).toFixed(0);
        } else if (this.redactIndex.amount == "amount_service_amount") {
          // 手续费赔款
          this.num = (
            item.num *
            item.confirm_price *
            item.service_rate *
            this.itemData.exchange_rate
          ).toFixed(0);
        } else {
          this.num = 0;
        }
      }
      if (this.radio == 2) {
        this.num = 0;
      }
      if (this.radio == 3 && this.num == "") {
        return this.$message.error("未输入自定义金额");
      }
      let item = this.amountRefundType.find((item) => item.key == this.radio);
      let datas = { type: item.key, amount: this.num, name: item.value };
      this.$parent.editSuccessfully(datas);
      this.dialogVisible = false;
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.radio = "";
        this.num = "";
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 15px;
}

.row {
  margin-bottom: 30px;
}

/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}
</style>